<dx-popup
   [resizeEnabled]="true"
   [dragEnabled]="true"
   [title]="this.title"
   [visible]="this.isVisible"
   (onShown)="this.onShown()"
   (onHidden)="this.onHidden()"
   height="auto"
   width="18vw"
   [minWidth]="300"
   >
   <div *dxTemplate="let data of 'content'" class="content-wrapper" #wrapper>

      <!-- One column per ORION, read top to bottom. APG ORION is the only one with settings today,
           so it is the only column and takes the full width. Hedging Grid ORION / OPG ORION columns
           go beside it when they gain settings.
           Layout (owner, 2026-09-08 screencast 2): a setting is TWO rows - label left + input right
           on one line, help text full-width beneath. The sections block fills the free height so the
           buttons stay anchored to the dialog's bottom edge on resize. No separator: the fieldset
           frame is the only boundary. -->
      <div class="sections">

         <fieldset class="section apg-orion" data-element="orion-settings-apg">
            <legend>APG ORION</legend>

            <div class="setting">
               <div class="row">
                  <div class="label">Show Top N Results</div>
                  <div class="input">
                     <dx-number-box [(value)]="this.apgShowTopN"
                                    [showSpinButtons]="true"
                                    [step]="1"
                                    format="#0"
                                    [inputAttr]="{style: 'text-align: center'}"
                     ></dx-number-box>
                  </div>
               </div>
               <div class="help">Max Amount of Result Cards APG ORION Can Offer. Default 5.</div>
            </div>

            <div class="setting">
               <div class="row">
                  <div class="label">Max Query Range (Days)</div>
                  <div class="input">
                     <dx-number-box [(value)]="this.apgMaxQueryRangeDays"
                                    [showSpinButtons]="true"
                                    [step]="1"
                                    format="#0"
                                    [inputAttr]="{style: 'text-align: center'}"
                     ></dx-number-box>
                  </div>
               </div>
               <div class="help">Max Width of the Query's Date Range in Calendar Days, Counted From Its Start Date. Default 21.</div>
            </div>

            <!-- CR-20260915-002: "Weekdays to exclude" (owner sketch, 2026-09-15): five boxes,
                 the day's name above and a checkbox below. Checked = the date block starts with
                 that weekday excluded; the trader may still toggle it per query. The APG ORION's
                 OWN set - Maven's lives in the MAVEN Settings dialog. -->
            <div class="setting" data-element="orion-settings-apg-weekdays">
               <div class="label">Weekdays to Exclude</div>
               <div class="weekdays">
                  <div class="weekday" *ngFor="let box of this.apgWeekdayExclusions"
                       [attr.data-element]="'weekday-' + box.id">
                     <div class="weekday-label">{{ box.text }}</div>
                     <dx-check-box [value]="box.checked"
                                   (onValueChanged)="this.onWeekdayChanged(box, $event)"></dx-check-box>
                  </div>
               </div>
               <div class="help">Weekdays Taken Out of a Date Range by Default. The Trader Can Still Toggle Any Day Per Query. Default: Mon.</div>
            </div>
         </fieldset>

         <!-- Maven is NOT an ORION (it orders from them), so its settings are NOT here: they have
              their own host-menu item and dialog, ets-maven-settings-dialog (2026-09-14). -->

      </div>

      <div class="buttons">
         <div class="button">
            <dx-button text="Save" width="100%" (onClick)="this.onSaveClicked()"></dx-button>
         </div>
         <div class="button">
            <dx-button text="Close" width="100%" (onClick)="this.onCloseClicked()"></dx-button>
         </div>
      </div>

      <dx-load-panel [visible]="this.isLoading" [position]="{my: 'center', at: 'center', of: wrapper}"></dx-load-panel>

   </div>
</dx-popup>
